var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1741 14.2031C12.481 14.2031 12.788 14.086 13.0089 13.875L14.6786 12.2813C14.8996 12.0703 15.0223 11.7774 15.0223 11.4844C15.0223 11.1914 14.8996 10.8984 14.6786 10.6875L11.0692 7.2422L14.6786 3.79688C14.8996 3.58594 15.0223 3.29297 15.0223 3C15.0223 2.70703 14.8996 2.41406 14.6786 2.20313L13.0089 0.609375C12.788 0.398438 12.481 0.28125 12.1741 0.28125C11.8672 0.28125 11.5603 0.398438 11.3393 0.609375L7.72992 4.05469L4.12054 0.609375C3.89956 0.398438 3.59264 0.28125 3.28572 0.28125C2.9788 0.28125 2.67188 0.398438 2.4509 0.609375L0.78125 2.20313C0.560268 2.41406 0.4375 2.70703 0.4375 3C0.4375 3.29297 0.560268 3.58594 0.78125 3.79688L4.39063 7.2422L0.78125 10.6875C0.560268 10.8984 0.4375 11.1914 0.4375 11.4844C0.4375 11.7774 0.560268 12.0703 0.78125 12.2813L2.4509 13.875C2.67188 14.086 2.9788 14.2031 3.28572 14.2031C3.59264 14.2031 3.89956 14.086 4.12054 13.875L7.72992 10.4297L11.3393 13.875C11.5603 14.086 11.8672 14.2031 12.1741 14.2031Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close-grey.879a604e3542a10c22bb0a44b2909516.svg";
export { ForwardRef as ReactComponent };